import {get, put} from './http';

export type ApolloRelayConfig = {
  /** The runtime switch. Defaults true when nothing has been saved yet. */
  enabled: boolean;
  /** Deploy-time Apollo:Topic for this environment, or null when unset. */
  topic: string | null;
  /** Whether `topic` is a usable fully-qualified name — false for blank *or* malformed. */
  topic_configured: boolean;
  affiliate_id: string | null;
  /** `enabled && topic_configured` — what actually governs whether anything sends. */
  sending: boolean;
  modified_by: string | null;
  modified_at: string | null;
};

export type UpdateApolloRelayConfigPayload = {enabled: boolean};

export const apolloRelayConfigApi = {
  get: async () => get<ApolloRelayConfig>('/apollo-relay-config'),
  update: async (payload: UpdateApolloRelayConfigPayload) =>
    put<UpdateApolloRelayConfigPayload, ApolloRelayConfig>('/apollo-relay-config', payload)
};
